import { render, staticRenderFns } from "./open-account-mt45.vue?vue&type=template&id=6890b5ca&scoped=true"
import script from "./open-account-mt45.vue?vue&type=script&lang=js"
export * from "./open-account-mt45.vue?vue&type=script&lang=js"
import style0 from "./open-account-mt45.vue?vue&type=style&index=0&id=6890b5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890b5ca",
  null
  
)

export default component.exports